/* unplugin-vue-components disabled */import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "i-layout-header-trigger i-layout-header-trigger-min"
};
var _hoisted_2 = {
  key: 0,
  class: "i-layout-header-user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Avatar = _resolveComponent("Avatar");
  var _component_Icon = _resolveComponent("Icon");
  var _component_DropdownItem = _resolveComponent("DropdownItem");
  var _component_i_link = _resolveComponent("i-link");
  var _component_DropdownMenu = _resolveComponent("DropdownMenu");
  var _component_Dropdown = _resolveComponent("Dropdown");
  var _directive_bg_color = _resolveDirective("bg-color");
  return _openBlock(), _createBlock(_component_Dropdown, {
    trigger: _ctx.isMobile ? 'click' : 'hover',
    class: _normalizeClass(["i-layout-header-user", {
      'i-layout-header-user-mobile': _ctx.isMobile
    }]),
    onOnClick: $options.handleClick
  }, {
    list: _withCtx(function () {
      return [_createVNode(_component_DropdownMenu, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_i_link, {
            to: "/setting/account"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_DropdownItem, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_Icon, {
                    type: "md-settings",
                    class: "ivu-mr-8"
                  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('basicLayout.user.setting')), 1 /* TEXT */)];
                }),
                _: 1 /* STABLE */
              })];
            }),
            _: 1 /* STABLE */
          }), _createVNode(_component_DropdownItem, {
            divided: "",
            name: "logout"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Icon, {
                type: "md-log-out",
                class: "ivu-mr-8"
              }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('basicLayout.user.logOut')), 1 /* TEXT */)];
            }),
            _: 1 /* STABLE */
          })];
        }),
        _: 1 /* STABLE */
      })];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_1, [_withDirectives(_createVNode(_component_Avatar, {
        icon: "ios-person",
        size: "small",
        src: _ctx.info.avatarUrl
      }, null, 8 /* PROPS */, ["src"]), [[_directive_bg_color, '#5da6ea']]), !_ctx.isMobile ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.info.nickName), 1 /* TEXT */)) : _createCommentVNode("v-if", true)])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger", "class", "onOnClick"]);
}